/* eslint-disable no-undef */
/* eslint-disable camelcase */

/**
 * This module causes webpack's runtime module resolution to work differently when prerendering views.
 * During prerender, the files are hosted on a local webserver, but when running in a real browser
 * they are hosted at the ASSET_URL.
 */

__webpack_public_path__ = window.__PRERENDER_INJECTED ? '/' : process.env.ASSET_URL;